import { render, staticRenderFns } from "./classStu.vue?vue&type=template&id=24bf2e55&"
import script from "./classStu.vue?vue&type=script&lang=js&"
export * from "./classStu.vue?vue&type=script&lang=js&"
import style0 from "./classStu.vue?vue&type=style&index=0&id=24bf2e55&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports